// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2
import FavoriteMeetingsCard, { FavoriteMeetingProps } from './FavoriteMeetingsCard';

export type { FavoriteMeetingProps };
export default FavoriteMeetingsCard;
